var render, staticRenderFns
import script from "./DraggableItem2.vue?vue&type=script&lang=js"
export * from "./DraggableItem2.vue?vue&type=script&lang=js"
import style0 from "./DraggableItem2.vue?vue&type=style&index=0&id=05e8d866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e8d866",
  null
  
)

export default component.exports